// Insets should be given as numerical percentages. E.g. `20` = 20%.
// Background example: `${ASSET_PREFIX}/images/green-background-right.svg`.
const HorizontalShard = ({ topLeftInset = 20, topRightInset = 0, bottomRightInset = 0, bottomLeftInset = 20, background, children, style }) => (
  <div className="container" style={style}>
    <img
      src={background}
      className="background"
      alt=""
    />

    { children }

    <style jsx>{`
      .container {
        position: relative;
        clip-path: polygon(0 ${topLeftInset}%, 100% ${topRightInset}%, 100% ${100 - bottomRightInset}%, 0 ${100 - bottomLeftInset}%);
        width: 100%;
        overflow: hidden;
      }
      
      .background {
        position: absolute;
        top: 0;
        left: -1%;
        height: 100%;
        width: 102%;
        object-fit: cover;
        z-index: -1;
      }
    `}</style>
  </div>
);

export default HorizontalShard;